<form [formGroup]="form" class="client-info__wrapper" (submit)="onSubmit()">
  <div class="row">
    <div class="col-6">
      <div class="form-group">
        <label for="">Company Name</label>
        <input
          type="text"
          class="lum-input"
          formControlName="business_name"
          [required]="true"
          placeholder="Company Name"
        />
        <mat-error *ngIf="businessNameControl && businessNameControl.invalid">{{
          businessNameControl | validateField
        }}</mat-error>
      </div>
    </div>
    <div class="col-6">
      <div class="form-group">
        <label for="">FEIN</label>
        <input
          type="text"
          class="lum-input"
          formControlName="fein"
          placeholder="FEIN"
        />
        <mat-error *ngIf="feinControl && feinControl.invalid">{{
          feinControl | validateField
        }}</mat-error>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <div class="form-group">
        <label for="">Client Type</label>
        <mat-select
          class="lum-select"
          formControlName="business_type_id"
          (selectionChange)="onSelectClientType($event)"
        >
          <mat-option *ngFor="let type of clientTypeList" [value]="type.value">
            {{ type.label }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="col-6">
      <div class="form-group">
        <label for="">Sales Rep Assignee</label>
        <lum-filter-multiselect-chips
          [selectedOptions]="salesRepAssigneeIds"
          [options]="salesRepAssigneesList"
          (selectOptionEvent)="onSelectRepAssignees($event)"
        ></lum-filter-multiselect-chips>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <label for="">Notes</label>
        <lum-ui-textarea
          ngDefaultControl
          placeholder=""
          formControlName="notes"
          [value]="notes"
        ></lum-ui-textarea>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <div class="form-group">
          <label for="">Client Tags</label>
          <lum-filter-tag
            ngDefaultControl
            formControlName="tags"
            label=""
            [value]="tags"
            (onFilterSelect)="onSetTags($event)"
          ></lum-filter-tag>
        </div>
      </div>
    </div>
  </div>
  <div class="lum-modal__footer mt-4 w-p100" mat-dialog-actions>
    <div class="flex ml-auto lum-modal__action">
      <button
        type="button"
        class="lum-button lum-button--secondary mr-2"
        mat-button
        [disabled]="true"
      >
        <lum-ui-icon
          icon="chevron-left"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Previous
      </button>

      <button
        mat-button
        type="submit"
        [disabled]="hasInvalidInput"
        class="lum-button"
      >
        Next
        <lum-ui-icon
          class="ml-2-5"
          icon="chevron-right"
          color="#ffffff"
          width="23"
          height="23"
        ></lum-ui-icon>
      </button>
    </div>
  </div>
</form>
